import { configureStore } from "@reduxjs/toolkit";
import claimReducer from "../store/claim";
import countyReducer from "../store/county";
import lookuptypeReducer from "../store/lookuptype";
import settingReducer from "../store/setting";
import stateReducer from "../store/state";
import userReducer from "../store/user";
import lookupvalueReducer from "../store/lookupvalue";
import lookupgroupReducer from "../store/lookupgroup";
import apiAlertReducer from "../store/apiAlert";

export const store = configureStore({
  reducer: {
    claim: claimReducer,
    county: countyReducer,
    lookupType: lookuptypeReducer,
    lookupValue: lookupvalueReducer,
    lookupGroup: lookupgroupReducer,
    setting: settingReducer,
    state: stateReducer,
    user: userReducer,
    apiAlert: apiAlertReducer,
  },
});
